import { StoreContactInfo } from '../../common';
import { DealerStore } from '../dealerStoreType';
import styles from '../DealerLocator.module.scss';

interface DealerLocatorStoreContactInfoProps {
  contactInfoDrivingDirectionsLabel: string;
  contactInfoEmailLabel: string;
  contactInfoTitle: string;
  contactInfoWebsiteLabel: string;
  returnContactUrl: (storeId?: string) => string;
  store: DealerStore;
  isStoreLocationOptimizationFlag?: boolean;
}

export const DealerLocatorStoreContactInfo = ({
  contactInfoDrivingDirectionsLabel,
  contactInfoEmailLabel,
  contactInfoTitle,
  contactInfoWebsiteLabel,
  returnContactUrl,
  store,
  isStoreLocationOptimizationFlag
}: DealerLocatorStoreContactInfoProps) => {
  const {
    address: { email, phone },
    geo: { latitude, longitude },
    website,
    storeId
  } = store;
  const contactUrl = returnContactUrl(storeId);

  return (
    <div
      className={`d-flex flex-column order-lg-1 ${styles['resp-width']}`}
      style={{ gap: 12 }}
    >
      <StoreContactInfo
        title={contactInfoTitle}
        phone={phone}
        email={email}
        contactUrl={contactUrl}
        emailLabel={contactInfoEmailLabel}
        website={website}
        websiteLabel={contactInfoWebsiteLabel}
        drivingDirectionsLabel={contactInfoDrivingDirectionsLabel}
        latitude={latitude}
        longitude={longitude}
        linkClassName="mt-1"
        linkTextClassName="cat-u-theme-typography-label"
        isStoreLocationOptimizationFlag={isStoreLocationOptimizationFlag}
      />
    </div>
  );
};
